import React, { useState, useEffect } from "react";
import styles from "./CookieConsent.module.css";
import { useTranslation } from "react-i18next";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowBanner(false); // Hide banner on acceptance
  };

  return (
    showBanner && (
      <div className={styles.banner}>
        <p>{t("cookies.description")}</p>
        <div>
          <button className={styles.button} onClick={acceptCookies}>
            {t("cookies.closeBtn")}
          </button>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
